<template>
  <custom-modal
    title="Work Schedule"
    :on-save="() => onSave(type, timezone, days)"
    :on-cancel="onCancel"
    custom-style="width: 570px;"
    content-style="padding: 20px 40px 35px 40px;"
  >
    <span class="description">Specify the time in which it will be comfortable to receive calls:</span>
    <div class="select-container">
      <div class="select-item" :class="{ 'select-item selected': type === 'all' }" @click="onSelectType('all')">
        <div class="select-circle" :class="{ 'select-circle selected': type === 'all' }"></div>
        Open 24/7
      </div>
      <div
        class="select-item"
        :class="{ 'select-item selected': type !== 'all' }"
        style="margin-left: 100px;"
        @click="onSelectType('hours')"
      >
        <div class="select-circle" :class="{ 'select-circle selected': type !== 'all' }"></div>
        Have business hours
      </div>
    </div>
    <div v-if="type !== 'all'">
      <dropdown
        custom-style="width: 100%; height: 40px;"
        :data="timezones"
        key-name="text"
        :selected-item="timezone"
        :on-select="onSelectTimezone"
        list-style="top: 40px;"
        title="Timezone"
      />
    </div>
    <div v-if="type !== 'all'" class="days-container">
      <div class="column">
        <div v-for="(day, index) in Object.keys(days)" :key="index" class="day-row">
          <checkbox :title="day" :checked="days[day].selected" :on-select="onCheck" />
          <div class="time-container">
            <dropdown
              v-if="days[day].selected"
              custom-style="width: 125px; height: 30px; background-color: #F4F5F7; border: 0.5px solid #E8EDF1;"
              :data="times"
              :selected-item="days[day].from"
              :on-select="onSelectTime(day, 'from')"
              list-style="top: 30px;"
              title="Time"
            />
            <dropdown
              v-if="days[day].selected"
              custom-style="width: 125px; height: 30px; background-color: #F4F5F7; border: 0.5px solid #E8EDF1; margin-left: 10px;"
              :data="times"
              :selected-item="days[day].to"
              :on-select="onSelectTime(day, 'to')"
              list-style="top: 30px;"
              title="Time"
            />
            <div v-if="!days[day].selected" class="closed-business">
              CLOSED FOR BUSINESS
            </div>
          </div>
        </div>
      </div>
      <div class="separator"></div>
    </div>
  </custom-modal>
</template>

<script>
import CustomModal from '@/components/CustomModal';
import Dropdown from '@/components/Dropdown';
import Checkbox from '@/components/Checkbox';

const tzs = [{ text: 'Eastern' }, { text: 'Central' }, { text: 'Mountain' }, { text: 'Pacific' }];

export default {
  name: 'ScheduleModal',
  components: { CustomModal, Dropdown, Checkbox },
  props: {
    onSave: Function,
    onCancel: Function,
    editing: Object
  },
  data() {
    return {
      type: 'all',
      timezone: tzs[0].text,
      days: {
        Monday: {
          selected: true,
          from: '9 AM',
          to: '6 PM'
        },
        Tuesday: {
          selected: true,
          from: '9 AM',
          to: '6 PM'
        },
        Wednesday: {
          selected: true,
          from: '9 AM',
          to: '6 PM'
        },
        Thursday: {
          selected: true,
          from: '9 AM',
          to: '6 PM'
        },
        Friday: {
          selected: true,
          from: '9 AM',
          to: '6 PM'
        },
        Saturday: {
          selected: false,
          from: '9 AM',
          to: '6 PM'
        },
        Sunday: {
          selected: false,
          from: '9 AM',
          to: '6 PM'
        }
      }
    };
  },
  computed: {
    timezones() {
      return tzs;
    },

    times() {
      const t = [];
      for (let i = 1; i <= 24; i++) {
        if (i === 12) {
          t.push('12 PM');
        } else if (i > 12) {
          t.push(i - 12 + ' PM');
        } else {
          t.push(i + ' AM');
        }
      }
      return t;
    }
  },
  mounted() {
    this.type = this.editing.type;
    if (this.editing.days) {
      this.timezone = this.editing.timezone;
      this.days = this.editing.days;
    }
  },
  methods: {
    onSelectType(t) {
      this.type = t;
    },

    onSelectTimezone(timezone) {
      this.timezone = timezone.text;
    },

    onSelectTime(day, when) {
      const ds = this.days;
      return (time) => {
        ds[day][when] = time;
      };
    },

    onCheck(day) {
      this.days[day].selected = !this.days[day].selected;
    }
  }
};
</script>

<style scoped lang="scss">
.description {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.01em;
  color: $colorText;
}

.select-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 15px;
  margin-bottom: 20px;

  .select-item {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.01em;
    color: $colorText;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;

    &.selected {
      color: #374561;
    }

    .select-circle {
      width: 19px;
      height: 19px;
      border-radius: 10px;
      border: 1px solid #c2c7cf;
      margin-right: 10px;

      &.selected {
        border: 6px solid $colorGreen;
      }
    }
  }
}

.days-container {
  display: flex;
  flex-direction: row;
  margin-top: 15px;
  position: relative;

  .column {
    display: flex;
    flex-direction: column;

    .day-row {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 10px 0;

      .time-container {
        width: 260px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        position: absolute;
        margin-left: 170px;

        .closed-business {
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          color: #c2c7cf;
        }
      }
    }
  }

  .separator {
    height: 270px;
    width: 1px;
    background-color: #e8edf1;
    position: absolute;
    margin-left: 135px;
    margin-top: 5px;
  }
}
</style>
